import { get } from "radashi";
import { normalizeArticleNumber } from "../normalize";
import manuallyAddedImagesMapping from "./manually-added.json";
import imagesMapping from "./mapping.json";

export function getProductImage(articleNumber: string) {
  const normalizedArticleNumber = normalizeArticleNumber(articleNumber);

  if (!normalizedArticleNumber) {
    return null;
  }

  return get(
    manuallyAddedImagesMapping,
    normalizedArticleNumber,
    get(imagesMapping, normalizedArticleNumber, null),
  );
}
